import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const GUIDE_VIDEOS = {
  en: '/assets/videos/HirePortal_Zoho_Setup_Guide_EN_voiceover.mp4',
  nl: '/assets/videos/HirePortal_Zoho_Handleiding_NL_voiceover-final.mp4',
};

const guideLocale = (language) => (
  String(language || '').toLowerCase().startsWith('nl') ? 'nl' : 'en'
);

const ZohoSetupGuide = () => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const locale = guideLocale(i18n.language);
  const videoSrc = GUIDE_VIDEOS[locale];

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) setIsOpen(false);
  };

  return (
    <>
      <Button
        type="button"
        variant="outline"
        iconName="Info"
        onClick={() => setIsOpen(true)}
      >
        {t('connectAts.guide.button')}
      </Button>

      {isOpen && createPortal(
        <div
          className="fixed inset-0 z-100 flex items-center justify-center bg-black/50 p-4"
          onClick={handleBackdropClick}
          role="dialog"
          aria-modal="true"
          aria-label={t('connectAts.guide.ariaLabel')}
        >
          <div
            className="bg-card rounded-lg border border-border shadow-elevation-lg max-w-3xl w-full p-4 md:p-6"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="flex items-start justify-between gap-4 mb-4">
              <h2 className="text-lg md:text-xl font-semibold text-foreground">
                {t('connectAts.guide.title')}
              </h2>
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label={t('connectAts.guide.close')}
              >
                <Icon name="X" size={20} />
              </button>
            </div>

            <video
              key={videoSrc}
              className="w-full rounded-lg bg-black"
              src={videoSrc}
              controls
              playsInline
              autoPlay
            >
              {t('connectAts.guide.unsupported')}
            </video>
          </div>
        </div>,
        document.body,
      )}
    </>
  );
};

export default ZohoSetupGuide;
